module.exports = __webpack_public_path__ + "./assets/fonts/Gilroy-Medium.ttf?90b750e150c3c8b773e1f04ffada4104";